import { useFeatureToggles } from '@grandvisionhq/state';

function usePrescriptionTypes() {
    const { isPrescriptionFileEnabled , featureConfigs  } = useFeatureToggles();
    const allPossibleTypes = [
        'EmailPrescription',
        'ExistingCustomer',
        'NewPrescription',
        'PrescriptionFile', 
    ];
    // Check if all environment variable types are valid
    const envTypes = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.prescriptionTypesOrder;
    if (envTypes && envTypes.every((type)=>allPossibleTypes.includes(type)
    )) {
        return [
            ...envTypes
        ];
    }
    // default behavior
    const finalTypes = [
        'NewPrescription',
        'ExistingCustomer'
    ];
    if (isPrescriptionFileEnabled) {
        finalTypes.push('EmailPrescription');
    }
    return finalTypes;
}

export { usePrescriptionTypes };
//# sourceMappingURL=use-prescription-types.js.map
